import React from 'react';
import { useNetwork } from '../../contexts/NetworkContext';
import { hardReload } from '../../shared/utils/hardReload';

/**
 * Full-screen overlay that blocks ALL app interaction while offline.
 * Rendered at the app root so it covers routing, layout, and auth screens.
 */
const OfflineOverlay: React.FC = () => {
  const { isOnline } = useNetwork();

  if (isOnline) return null;

  return (
    <div
      role="alertdialog"
      aria-live="assertive"
      aria-label="You are offline"
      className="fixed inset-0 z-[9999] flex items-center justify-center bg-gray-900/80 backdrop-blur-sm px-6"
    >
      <div className="w-full max-w-sm rounded-2xl bg-white p-8 text-center shadow-xl">
        <div className="mx-auto mb-4 flex h-14 w-14 items-center justify-center rounded-full bg-red-100">
          <span className="text-2xl" aria-hidden="true">&#128246;</span>
        </div>
        <h2 className="text-lg font-bold text-gray-900">You&apos;re offline</h2>
        <p className="mt-2 text-sm text-gray-600">
          Reconnect to the internet to continue. Your work can&apos;t be saved until you&apos;re back online.
        </p>
        <button
          type="button"
          onClick={hardReload}
          className="mt-6 w-full rounded-lg bg-primary-500 px-4 py-2 font-semibold text-white hover:bg-primary-600"
        >
          Reload app
        </button>
      </div>
    </div>
  );
};

export default OfflineOverlay;
